module.exports = __webpack_public_path__ + "static/background-noise-c73193744728e8b16814ba01f24898fe.png";